<template>
    <div class="containerSytle2" v-show="frank">
        <div class="navSide">
            <button @click="clickHdandle01">
                <h3>车牌识别一体机</h3>
            </button>
            <button @click="clickHdandle02">
                <h3>智能道闸</h3>
            </button>
            <button @click="clickHdandle03">
                <h3>直杆道闸</h3>
            </button>
            <button @click="clickHdandle04">
                <h3>广告道闸</h3>
            </button>
            <button @click="clickHdandle05">
                <h3>栅栏道闸</h3>
            </button>
            <button @click="clickHdandle06">
                <h3>车位引导与反向寻车</h3>
            </button>
        </div>
        <div class="mainStyle2">
            <section id="section01">
                <h3>车牌识别一体机</h3>
                <ul class="containerList">
                    <li class="cell" @click="goToParkingDetail($event, 'B9201')">
                        <img src="../../assets/parking/B9201.jpg" alt="">
                    </li>
                    <li class="cell" @click="goToParkingDetail($event, 'B9401')">
                        <img src="../../assets/parking/B9401.jpg" alt="">
                    </li>
                    <li class="cell" @click="goToParkingDetail($event, 'B9201C')">
                        <img src="../../assets/parking/B9201C.jpg" alt="">
                    </li>
                    <li class="cell" @click="goToParkingDetail($event, 'B9401C')">
                        <img src="../../assets/parking/B9401C.jpg" alt="">
                    </li>
                    <li class="cell" @click="goToParkingDetail($event, 'B9202')">
                        <img src="../../assets/parking/B9202.jpg" alt="">
                    </li>
                    <li class="cell" @click="goToParkingDetail($event, 'B9202C')">
                        <img src="../../assets/parking/B9202C.jpg" alt="">
                    </li>
                    <li class="cell" @click="goToParkingDetail($event, 'B9203')">
                        <img src="../../assets/parking/B9203.jpg" alt="">
                    </li>
                </ul>
            </section>
            <section id="section02">
                <h3>智能道闸</h3>
                <ul class="containerList">
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                </ul>
            </section>
            <section id="section03">
                <h3>直杆道闸</h3>
                <ul class="containerList">
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                </ul>
            </section>
            <section id="section04">
                <h3>广告道闸</h3>
                <ul class="containerList">
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                </ul>
            </section>
            <section id="section05">
                <h3>栅栏道闸</h3>
                <ul class="containerList">
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                </ul>
            </section>
            <section id="section06">
                <h3>车位引导与反向寻车</h3>
                <ul class="containerList">
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                    <li class="cell">
                        <img src="../../assets/02.jpg" alt="">
                    </li>
                </ul>
            </section>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            frank: true
        }
    },
    watch: {
        '$route'(to, from) {
            // 如果路由包含 Parking/:id，隐藏列表
            this.frank = !to.path.includes('/Product/Parking/')
        }
    },
    mounted() {
        // 初始化显示状态
        this.frank = !this.$route.path.includes('/Product/Parking/')
    },
    methods: {
        goToParkingDetail(event, id) {
            // this.frank = false
            console.log(event.target)
            console.log("点击了列表")
            console.log(id)
            this.$router.push(`/Product/Parking/${id}`)
                .then(() => {
                    console
                        .log('导航成功到:', id)
                })
                .catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        console
                            .error('导航错误:', err)
                    }
                })

        },
        clickHdandle01(event) {
            const el01 = document.getElementById("section01")
            const offsetTop = el01.offsetTop - 100 // 考虑导航栏高度                
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            })
        },
        clickHdandle02(event) {
            const el02 = document.getElementById("section02")
            const offsetTop = el02.offsetTop - 100 // 考虑导航栏高度                
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            })
        },
        clickHdandle03(event) {
            const el03 = document.getElementById("section03")
            const offsetTop = el03.offsetTop - 100 // 考虑导航栏高度                
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            })
        },
        clickHdandle04(event) {
            const el04 = document.getElementById("section04")
            const offsetTop = el04.offsetTop - 100 // 考虑导航栏高度                
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            })
        },
        clickHdandle05(event) {
            const el05 = document.getElementById("section05")
            const offsetTop = el05.offsetTop - 100 // 考虑导航栏高度                
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            })
        },
        clickHdandle06(event) {
            const el06 = document.getElementById("section06")
            const offsetTop = el06.offsetTop - 100 // 考虑导航栏高度                
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            })
        }

    }
}
</script>
<style scoped>
h3 {
    font-size: 30px;
}

.containerSytle2 {
    width: 100%;
    border: 1px solid rgba(5, 12, 15, 0.936);
    display: flex;
}

.navSide {
    width: 300px;
    border: 1px solid red;
    position: sticky;
    align-self: flex-start;
    margin-left: 200px;
    top: 150px;
}

.navSide h3 {
    width: 280px;
    height: 100px;
    border: 1px solid red;
    line-height: 100px;
    margin: 15px;
}

.containerList {
    width: 2000px;
    list-style: none;
    border: 1px solid red;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-left: 8%;
}

.containerList .cell {
    width: 600px;
    height: 600px;
    margin: 30px 0;
    border: 1px solid rgb(12, 186, 79);
}

.containerList .cell img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>